import { getSessionConversionStatsThunk } from '../../thunk/sessionConversion';

export default {
    [getSessionConversionStatsThunk.pending as any]: (state) => {
        state.status = 'loading';
        state.error = null;
    },
    [getSessionConversionStatsThunk.fulfilled as any]: (state, action) => {
        state.status = 'resolved';
        
        // Update cached days if new data was fetched
        if (action.payload.newCachedDays) {
            state.cachedDays = {
                ...state.cachedDays,
                ...action.payload.newCachedDays
            };
        }
        
        // Store the result (without newCachedDays)
        state.data = {
            aggregate: action.payload.aggregate,
            dailyStats: action.payload.dailyStats
        };
        
        state.queryParams = { ...action.meta.arg };
    },
    [getSessionConversionStatsThunk.rejected as any]: (state, action) => {
        state.status = 'rejected';
        state.error = action.payload;
    }
};

